/* istanbul ignore file */
import { html, LitElement, property, TemplateResult } from 'lit-element';

// TODO replace all instances of extension with the mixin, swap to help-modal, or get to PVD3
export class ApexLabelModal extends LitElement {
  @property({ type: Boolean, reflect: true, attribute: 'icon-left' })
  public iconLeft = false;

  @property({ type: String, attribute: 'group-label' })
  public groupLabel: string | undefined = undefined;

  @property({ type: String, attribute: 'help-header' })
  public helpHeader = '';

  @property({ type: String, attribute: 'help-body' })
  public helpBody = '';

  @property({ type: String, attribute: 'help-size' })
  public helpSize = '';

  @property({ type: Boolean, attribute: 'stack' })
  public stack = false;

  public createHelpLink(id: string): TemplateResult {
    return html`
      <a href="javascript:void(0);" id="${id}-modal-trigger">
        <pvd-icon icon="help" class="m-small-left"></pvd-icon>
      </a>
    `;
  }

  public createHelpModal(id: string): TemplateResult {
    return html`
      <pvd-modal id="${id}-modal" for="${id}-modal-trigger" class="${this.helpSize || ''}">
        <div slot="modal-header">
          <h2 class="pvd-heading-L">${this.helpHeader}</h2>
        </div>
        <div slot="modal-body">
          <div class="pvd-container">
            <p>${this.helpBody}</p>
          </div>
        </div>
      </pvd-modal>
    `;
  }

  public createLabel(id: string, groupLabel: string, helpLink: TemplateResult, labelFor?: string): TemplateResult {
    if (id && groupLabel && helpLink) {
      const defaultClass = 'form-row-label label-icon';
      const labelClass = this.stack ? `${defaultClass} toggle-button-stacked` : defaultClass;
      const labelText = this.iconLeft ? html`${helpLink}${groupLabel}` : html`${groupLabel}${helpLink}`;

      if (labelFor) {
        return html`<div class="${labelClass}">
          <label id="${id}" for="${labelFor}">${labelText}</label>
        </div>`;
      }
      return html`<div class="${labelClass}">
        <label id="${id}">${labelText}</label>
      </div>`;
    }
    return html``;
  }
}

export function apexLabelModalMixin<T extends { new (...args: unknown[]): T }>(constructor: T): unknown {
  Object.defineProperty(constructor.prototype, 'iconLeft', {
    get(): boolean {
      return this.hasAttribute('icon-left');
    },
    set(newValue: boolean) {
      if (newValue) {
        this.setAttribute('icon-left', '');
      } else {
        this.removeAttribute('icon-left');
      }
    }
  });

  Object.defineProperty(constructor.prototype, 'groupLabel', {
    get(): string {
      return this.getAttribute('group-label');
    },
    set(newValue: string) {
      this.setAttribute('group-label', newValue);
    }
  });

  Object.defineProperty(constructor.prototype, 'helpHeader', {
    get(): string {
      return this.getAttribute('help-header');
    },
    set(newValue: string) {
      this.setAttribute('help-header', newValue);
    }
  });

  Object.defineProperty(constructor.prototype, 'helpBody', {
    get(): string {
      return this.getAttribute('help-body');
    },
    set(newValue: string) {
      this.setAttribute('help-body', newValue);
    }
  });

  Object.defineProperty(constructor.prototype, 'helpSize', {
    get(): string {
      return this.getAttribute('help-size');
    },
    set(newValue: string) {
      this.setAttribute('help-size', newValue);
    }
  });

  Object.defineProperty(constructor.prototype, 'stack', {
    get(): boolean {
      return this.hasAttribute('stack');
    },
    set(newValue: boolean) {
      if (newValue) {
        this.setAttribute('stack', '');
      } else {
        this.removeAttribute('stack');
      }
    }
  });

  Object.defineProperty(constructor.prototype, 'createHelpLink', {
    value(id: string): TemplateResult {
      return html`
        <a href="javascript:void(0);" id="${id}-modal-trigger">
          <pvd-icon icon="help" class="m-small-left"></pvd-icon>
        </a>
      `;
    }
  });

  Object.defineProperty(constructor.prototype, 'createHelpModal', {
    value(id: string): TemplateResult {
      return html`
        <pvd-modal id="${id}-modal" for="${id}-modal-trigger" class="${this.helpSize || ''}">
          <div slot="modal-header">
            <h2 class="pvd-heading-L">${this.helpHeader}</h2>
          </div>
          <div slot="modal-body">
            <div class="pvd-container">
              <p>${this.helpBody}</p>
            </div>
          </div>
        </pvd-modal>
      `;
    }
  });

  Object.defineProperty(constructor.prototype, 'createLabel', {
    value(id: string, groupLabel: string, helpLink: TemplateResult, labelFor?: string): TemplateResult {
      if (id && groupLabel && helpLink) {
        const defaultClass = 'form-row-label label-icon';
        const labelClass = this.stack ? `${defaultClass} toggle-button-stacked` : defaultClass;
        const labelText = this.iconLeft ? html`${helpLink}${groupLabel}` : html`${groupLabel}${helpLink}`;

        if (labelFor) {
          return html`<div class="${labelClass}">
            <label id="${id}" for="${labelFor}">${labelText}</label>
          </div>`;
        }
        return html`<div class="${labelClass}">
          <label id="${id}">${labelText}</label>
        </div>`;
      }
      return html``;
    }
  });

  return constructor;
}

export default ApexLabelModal;
